import ConfirmDialog from "../../components/customHelpers/ConfirmDialog";
import Controls from "../../components/controls/Controls";
import Norecords from "../../components/customHelpers/Norecords";
import Loading from "../../components/customHelpers/Loading";
import DownloadIcon from "@mui/icons-material/Download";

import Layout from "../../components/layout/Layout";
import {
  TableBody,
  TableRow,
  TableCell,
  Typography,
  makeStyles,
} from "@material-ui/core";

import { Grid, Toolbar, InputAdornment } from "@material-ui/core";
import { useEffect, useRef, useState } from "react";
import UploadFileIcon from "@mui/icons-material/UploadFile";

import { MdOutlineDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { AiOutlineSearch } from "react-icons/ai";
import useTable from "../../components/customHelpers/usePaginationTable";
import Notify from "../../components/customHelpers/Notify";
import Notification from "../../components/customHelpers/Notification";
import { FiEdit, FiEye } from "react-icons/fi";

import Admin from "../../components/auth/Admin";
import AddCustomerForm from "../../components/forms/addCustomer";
import Customer from "../../actions/customer";
import Popup from "../../components/customHelpers/Popup";
import produce from "immer";
import { Box, MenuItem, Pagination, Paper, Select } from "@mui/material";
import { useHistory } from "react-router-dom";
import SaveCustomersFromFile from "../../components/SaveCutomerFromFile";
import ImportFile from "../../actions/ImportFile";
import { Image_API } from "../../config";
const headCells = [
  { id: "fullName", label: "FullName" },
  { id: "email", label: "email" },
  { id: "phoneNo", label: "Phone" },
  { id: "location", label: "Location" },
  { id: "address", label: "Address" },
  { id: "contact", label: "Contact" },
  { id: "actions", label: "Actions", disableSorting: true },
];

const useStyles = makeStyles((theme) => ({
  image: {
    borderRadius: "55%",
    height: "45px",
    width: "45px",
  },
  paginationContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "end",
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  pageSizeSelect: {
    minWidth: 120,
    marginRight: theme.spacing(2),
  },
}));
const CustomerPage = () => {
  const classes = useStyles();
  const { data, colDefs, importExcel, setData } = ImportFile();
  const filePicker = useRef(null);
  const history = useHistory();
  const { NotifyMessage, notify, setNotify } = Notify();
  const { viewAllCustomersWithPages, deleteCustomer } = Customer();
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);
  const [edite, setEdit] = useState(false);
  const [page, setPage] = useState(1);
  const [tot, setTot] = useState(1);
  const [limit, setLimit] = useState(15);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [actualTotal, setActualTotal] = useState();
  const pageSizes = [15, 25, 50, 100];
  const [openPopupBulkSave, setOpenPopupBulkSave] = useState(false);
  const [record, setRecord] = useState({
    data: [],
    colDefs: [],
  });
  const [customers, setCustomers] = useState([]);
  const [values, setValues] = useState({
    loading: false,
    reload: false,
  });
  const { loading, reload } = values;
  useEffect(() => {
    getAllCustomers();
  }, [reload, page, limit, searchQuery]);
  if (data && data.length != 0) {
    setRecord({ data, colDefs });
    setData([]);
    setOpenPopupBulkSave(true);
  }
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: "",
    subTitle: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const getAllCustomers = () => {
    setValues({ ...values, loading: true });
    viewAllCustomersWithPages(page, limit, searchQuery).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({
          ...values,
          loading: false,
        });
      } else if (data.customers) {
        setValues({
          ...values,
          loading: false,
        });
        setCustomers(data.customers);
        setTotalPages(Math.ceil(data.total / limit));
        setTot(data.pagination.totalPages);
        setActualTotal(data.pagination.total);
      }
    });
  };
  const onDelete = (Id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false,
    });
    setValues({ ...values, loading: true });
    deleteCustomer(Id).then((data) => {
      if (data.err) {
        NotifyMessage({
          message: data.err,
          type: "error",
        });
        setValues({ ...values, loading: false });
      } else {
        NotifyMessage({
          message: data.message,
          type: "success",
        });
        setValues({ ...values, loading: false });
        setCustomers(
          produce(customers, (draft) => {
            const index = customers.findIndex((item) => item.id === Id);
            if (index !== -1) draft.splice(index, 1);
          })
        );
      }
    });
  };
  const { TblContainer, TblHead, recordsAfterSortingAndFiltering } = useTable(
    customers,
    headCells,
    filterFn
  );

  const handleSearch = (e) => {
    setPage(1);
    setSearchQuery(e.target.value);
  };

  const handleDownload = () => {
    fetch(`${Image_API}/download/customer`)
      .then((response) => {
        if (response.ok) {
          return response.blob();
        }
        throw new Error("Network response was not ok.");
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "customer.xlsx");
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch((error) => {
        NotifyMessage({
          message: "There was a problem with your fetch operation:",
          type: "error",
        });
        console.error("There was a problem with your fetch operation:", error);
      });
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (event) => {
    setLimit(event.target.value);
    setPage(1);
  };
  const startIndex = (page - 1) * limit + 1;
  const endIndex = Math.min(startIndex + limit - 1, actualTotal);
  return (
    <Layout>
      <Admin>
        <div className="card">
          <Typography variant="h6" className="page-header">
            Customers
          </Typography>
          <Toolbar>
            <Controls.Input
              label="Search Customer"
              className="searchInput"
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AiOutlineSearch />
                  </InputAdornment>
                ),
              }}
              onChange={handleSearch}
            />

            <Grid container spacing={1}>
              <Grid item xs={12} sm={4}>
                <Controls.Button
                  color="primary"
                  onClick={() => {
                    filePicker.current.click();
                  }}
                  startIcon={<UploadFileIcon />}
                  variant="outlined"
                  text="Import file"
                  className="newButton"
                  fullWidth
                />
                <input
                  label="Icon"
                  name="image"
                  type="file"
                  hidden
                  ref={filePicker}
                  onChange={importExcel}
                  autoFocus={true}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Controls.Button
                  color="primary"
                  onClick={() => {
                    handleDownload();
                  }}
                  startIcon={<DownloadIcon />}
                  variant="outlined"
                  text="Download"
                  className="newButton"
                  fullWidth
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <Controls.Button
                  text="Add Customer"
                  variant="outlined"
                  startIcon={<IoMdAdd />}
                  className="newButton"
                  onClick={() => {
                    setOpenPopup(true);
                    setRecordForEdit(null);
                    setEdit(false);
                  }}
                />
              </Grid>
            </Grid>
          </Toolbar>

          <Grid container>
            <Grid item xs={12} className="card__body">
              {loading ? (
                <Loading />
              ) : (
                <Paper style={{ overflowX: "auto" }}>
                  <TblContainer>
                    <TblHead />
                    <TableBody>
                      {recordsAfterSortingAndFiltering().length > 0 ? (
                        recordsAfterSortingAndFiltering().map((item) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.fullName}</TableCell>
                            <TableCell>{item.email}</TableCell>
                            <TableCell>{item.phoneNo}</TableCell>
                            <TableCell>{item.location}</TableCell>
                            <TableCell>{item.address}</TableCell>
                            <TableCell>{item.contact}</TableCell>
                            <TableCell>
                              <Controls.ActionButton
                                color="secondary"
                                title="Delete"
                                onClick={() => {
                                  setConfirmDialog({
                                    isOpen: true,
                                    title:
                                      "Are you sure to delete this Customer?",
                                    subTitle: "You can't undo this operation",
                                    onConfirm: () => {
                                      onDelete(item.id);
                                    },
                                  });
                                }}
                              >
                                <MdOutlineDelete fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="Update"
                                onClick={() => {
                                  setOpenPopup(true);
                                  setRecordForEdit(item);
                                  setEdit(true);
                                }}
                              >
                                <FiEdit fontSize="medium" />
                              </Controls.ActionButton>
                              <Controls.ActionButton
                                color="primary"
                                title="View Detail"
                                onClick={() => {
                                  history.push(`/customer/order/${item.id}`);
                                }}
                              >
                                <FiEye fontSize="medium" />
                              </Controls.ActionButton>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <Norecords col={6} />
                      )}
                    </TableBody>
                  </TblContainer>
                  <Box className={classes.paginationContainer}>
                    <Box display="flex" alignItems="center">
                      <Typography variant="body2" style={{ marginRight: 8 }}>
                        Rows per page:
                      </Typography>
                      <Select
                        value={limit}
                        onChange={handlePageSizeChange}
                        className={classes.pageSizeSelect}
                        size="small"
                      >
                        {pageSizes.map((size) => (
                          <MenuItem key={size} value={size}>
                            {size}
                          </MenuItem>
                        ))}
                      </Select>
                    </Box>
                    {actualTotal && (
                      <span>
                        {" "}
                        {startIndex}-{endIndex} of {actualTotal}
                      </span>
                    )}
                    {customers.length > 0 && (
                      <Pagination
                        count={totalPages}
                        page={page}
                        onChange={handlePageChange}
                        color="primary"
                        hideNextButton={page === tot || customers.length === 0}
                        hidePrevButton={page === 1}
                        shape="rounded"
                        siblingCount={1}
                        disabled={customers.length === 0}
                      />
                    )}
                  </Box>
                </Paper>
              )}
            </Grid>
          </Grid>

          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
          <Notification notify={notify} setNotify={setNotify} />
        </div>
        <Popup
          title="Customer Form"
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddCustomerForm
            NotifyMessage={NotifyMessage}
            setOpenPopup={setOpenPopup}
            recordForEdit={recordForEdit}
            setCustomer={setCustomers}
            edite={edite}
          />
        </Popup>
        <Popup
          title="Import Customers"
          openPopup={openPopupBulkSave}
          setOpenPopup={setOpenPopupBulkSave}
          maxWidth={false}
        >
          <SaveCustomersFromFile
            file={record}
            NotifyMessage={NotifyMessage}
            setOpenPopupBulkSave={setOpenPopupBulkSave}
            getAllCustomers={getAllCustomers}
            customers={customers}
          />
        </Popup>
      </Admin>
    </Layout>
  );
};

export default CustomerPage;
